// Formats a size (e.g. an area in sqft) with a K/M/B/T suffix.
// Registered as the global `formatSize` Vue filter in main.js.
//
// The suffix index is clamped to the available suffixes, so values >= 1e15
// keep the `T` suffix with a larger mantissa (instead of printing `undefined`),
// and values below 1 use no suffix.
const SIZES = ['', 'K', 'M', 'B', 'T'];
const K = 1000;

export function formatSize(value) {
  if (!value) return '0 B';
  const x = Number(value);
  if (Number.isNaN(x)) return '0 B';
  if (!Number.isFinite(x)) return '∞';
  if (x < 0) return '-' + formatSize(-x);
  const i = Math.min(Math.max(Math.floor(Math.log(x) / Math.log(K)), 0), SIZES.length - 1);
  return parseFloat((x / Math.pow(K, i)).toFixed(2)) + ' ' + SIZES[i];
}
